import audiCanonicalOverrides from './audi';
import volkswagenCanonicalOverrides from './volkswagen';

const canonicalOverrides: Record<string, string> = {
  ...audiCanonicalOverrides,
  ...volkswagenCanonicalOverrides,
};

export default canonicalOverrides;
